'use client';

import React from 'react';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';
import type { HospitalCardsProps } from './types';
import { HospitalCard } from './HospitalCard';

export function HospitalCards({ hospitals }: HospitalCardsProps) {
  if (!hospitals?.length) return null;

  return (
    <div className="mt-3 w-full">
      <Carousel
        opts={{
          align: 'start',
          dragFree: true,
          containScroll: 'trimSnaps',
        }}
        className="w-full"
      >
        <CarouselContent className="">
          {hospitals.map((hospital, index) => {
            const isFirst = index === 0;
            const isLast = index === hospitals.length - 1;
            return (
              <React.Fragment key={hospital.id}>
                <CarouselItem
                  className={
                    isFirst
                      ? 'basis-[170px] pl-5 md:basis-[200px]'
                      : 'basis-[166px] pl-4 md:basis-[196px]'
                  }
                >
                  <HospitalCard h={hospital} />
                </CarouselItem>
                {isLast && (
                  <CarouselItem key={`spacer-${hospital.id}`} className="basis-5">
                    <div className="w-5" />
                  </CarouselItem>
                )}
              </React.Fragment>
            );
          })}
        </CarouselContent>
      </Carousel>
    </div>
  );
}
